// @ts-nocheck

/**
 * MSI3 Constants
 * 
 * Centralized constants for the MSI3 Revenue Sharing system.
 * Separated to avoid circular dependency issues.
 */

// Constants
export const MSI3_CONSTANTS = {
  // Revenue share percentages based on market penetration
  REVENUE_TIERS: {
    LOW_PENETRATION: { maxPercent: 33, revenueShare: 75 },
    MEDIUM_PENETRATION: { maxPercent: 66, revenueShare: 50 },
    HIGH_PENETRATION: { maxPercent: 100, revenueShare: 25 },
  },
  
  // Token limits by subscription tier (matches useRateLimit.js)
  TOKEN_LIMITS: {
    free: 50000,
    small: 100000,
    medium: 400000,
    large: 1000000,
  },
  
  // Annual pricing by geographic tier (in USD)
  PRICING: {
    TIER_1: { // Kenya, Nigeria, most of Africa
      free: 0,
      small: 6,
      medium: 9.71,
      large: 11.88,
    },
    TIER_2: { // India, South America, SE Asia
      free: 0,
      small: 12,
      medium: 19.42,
      large: 23.76,
    },
    TIER_3: { // Europe, Japan, South Korea
      free: 0,
      small: 18,
      medium: 29.12,
      large: 35.64,
    },
    TIER_4: { // US, Canada, Australia, Switzerland
      free: 0,
      small: 24,
      medium: 38.83,
      large: 47.52,
    },
  },
  
  // Protection periods
  EARLY_ADOPTER_PROTECTION_MONTHS: 36,
  STANDARD_PROTECTION_MONTHS: 18,
  LOOKBACK_DAYS: 90,
  
  // City detection methods
  CITY_DETECTION: {
    USER_SELECTED: 'user_selected',
    IP_GEOLOCATION: 'ip_geolocation',
    FACILITY_DEFAULT: 'facility_default',
  },
  
  // Revenue share statuses
  REVENUE_STATUS: {
    ACTIVE: 'active',
    PAUSED: 'paused',
    TRANSFERRED: 'transferred',
    NONE: 'none',
  },
  
  // Partnership statuses
  PARTNERSHIP_STATUS: {
    PROSPECT: 'prospect',
    NEGOTIATING: 'negotiating',
    SIGNED: 'signed',
    ACTIVE: 'active',
  },
  
  // Tokens per average chat (for "chats left" estimation)
  TOKENS_PER_CHAT_ESTIMATE: 5000,
};

export default MSI3_CONSTANTS;

